import Vue from 'vue'
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email, confirmed, ext, size } from 'vee-validate/dist/rules'
import VTextFieldWithValidation from '@/components/validators/VTextFieldWithValidation.vue'
import VFileInputWithValidation from '@/components/validators/VFileInputWithValidation.vue'
import PhoneNumber from 'awesome-phonenumber'

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('VTextFieldWithValidation', VTextFieldWithValidation)
Vue.component('VFileInputWithValidation', VFileInputWithValidation)

extend('required', {
  ...required,
  message: 'Toto pole je povinné',
})

extend('email', {
  ...email,
  message: 'E-mail nemá správný formát',
})

extend('confirmed-password', {
  ...confirmed,
  message: 'Hesla nesouhlasí',
})

extend('password', {
  message: 'Heslo musí mít víc nebo rovno 6 znaků',
  validate(ean) {
    return new Promise((resolve) => {
      resolve({ valid: ean.length >= 6 })
    })
  },
})

extend('order-label', {
  message: 'Povoleno maximálně 20 znaků',
  validate(label) {
    return new Promise((resolve) => {
      resolve({ valid: label.length <= 20 })
    })
  },
})

extend('order-attachment-name', {
  message: 'Povoleno maximálně 50 znaků',
  validate(label) {
    return new Promise((resolve) => {
      resolve({ valid: label.length <= 50 })
    })
  },
})

extend('phone', {
  message: 'Telefonní číslo není validní',
  validate(value) {
    return new Promise((resolve) => {
      const phone = new PhoneNumber(value)
      resolve({ valid: phone.isValid() })
    })
  },
})

extend('ext', {
  ...ext,
  message: 'Soubor nemá validní formát',
})

extend('size', {
  ...size,
  message: 'Překročena maximální velikost přílohy 10 MB.',
  validate(value) {
    return new Promise((resolve) => {
      resolve({ valid: !value.some((file) => file.size / 1024 / 1024 > 10) })
    })
  },
})
